import React from 'react';
import './index.scss';

function Page() {
    return (
        <div>关于我们</div>
    );
}

export default Page